// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"855272af","213":"ba6a3a3e","429":"d5b9e3b8","530":"f1e259f8","564":"fed66602","647":"db5ff36c"}[chunkId] + ".chunk.js";
};